const partyAttributeNameByKey: Record<string, string> = {
  brandOwner: 'Brand Owner',
  applicant: 'Applicant',
  productionSite: 'Production Site',
  localRepresentative: 'Local Representative',
  ownerReference: 'Owner Reference',
  authorizedRep: 'Authorized Rep',
}

export const CertificateDetailsUtils = {
  getPartyAttributeName: (attributeName: any) => {
    return partyAttributeNameByKey[attributeName] ?? attributeName
  },
}
